<template minapp='mpx' xlang='wxml'>
  <view class="fill-box" wx:class="{{customFillboxClass}}" style="width: 100vw;height:{{paddingTop}}px"></view>
  <view class="es-navbar custom-class">
    <view class="es-navbar__left" bindtap="clickLeft" wx:style="{{{color: leftColor}}}">
      <es-icon
        color="{{leftColor}}"
        size="{{leftIconSize}}"
        wx:if="{{leftArrow && !hideNavBar}}"
        name="angle-left"
      ></es-icon>
      <text class="es-navbar__left-text" wx:if="{{left}}">{{ left }}</text>
      <slot wx:else name="left"></slot>
    </view>
    <view class="es-navbar__title custom-title">
      <text class="es-navbar__text" wx:if="{{title}}">{{ title }}</text>
      <slot wx:else></slot>
    </view>
    <view class="es-navbar__right" bindtap="clickRight">
      <text wx:if="{{right}}">{{ right }}</text>
      <slot wx:else name="right"></slot>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { is } from '@didi/webx-js'

  createComponent({
    classes: ['custom-class', 'custom-title'],
    props: {
      left: String,
      title: String,
      right: String,
      leftColor: String,
      leftArrow: {
        type: Boolean,
        value: true
      },
      leftIconSize: {
        type: Number,
        optionalTypes: [String],
        value: 25
      },
      onClickLeft: null,
      useWebBack: false, // 使用web方法返回上一页
      page: String, // 区分页面，埋点使用
      customFillboxClass: String,
    },
    computed: {
      ...store.mapState({
        safeAreaTop: 'common.safeAreaTop'
      }),
      hideNavBar() {
        // 微信 & 阿里小程序隐藏代码的title bar
        return is('miniprogram.weixin') || is('miniprogram.alipay')
      }
    },
    attached() {
      if (is('passenger')) {
        if (is('ios')) {
          this.paddingTop = this.safeAreaTop || 38
        } else {
          this.paddingTop = 38
        }
      }
      mpx.getSystemInfo().then((e) => {
        if (e.statusBarHeight) {
          console.log('222e.statusBarHeight', e.statusBarHeight)
          if (__mpx_mode__ === 'web' && e.safeArea.top > 20) {
            // 刘海屏幕
            this.paddingTop = e.statusBarHeight - 10
          } else {
            this.paddingTop = e.statusBarHeight
          }
        }
      })
    },
    data: {
      paddingTop: 0
    },
    methods: {
      clickLeft() {
        this.$trigger('click-left')
        if (this.onClickLeft) {
          return this.onClickLeft()
        }
        if (this.useWebBack) {
          window.history.back()
        } else {
          mpx.$mpxRouter.goback()
        }
      },
      clickRight() {
        this.$trigger('click-right')
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '../icon/index'
    }
  }
</script>

